export const shouldBlockNumericKeypress = (event, currentValue) => {
  const key = event.key;
  if (key.length !== 1) return false;
  const current = String(currentValue ?? "");
  if (/\d/.test(key)) return false;
  if (key === "." && !current.includes(".")) return false;
  if (
    key === "-" &&
    event.target.selectionStart === 0 &&
    !current.includes("-")
  ) {
    return false;
  }
  return true;
};

export const sanitizeNumericPaste = (
  pastedText,
  currentValue,
  selectionStart = null,
  selectionEnd = null,
) => {
  const current = String(currentValue ?? "");
  const start = selectionStart ?? current.length;
  const end = selectionEnd ?? current.length;
  const merged =
    current.slice(0, start) + String(pastedText ?? "") + current.slice(end);

  let cleaned = merged.replace(/[^\d.\-]/g, "");
  cleaned = cleaned.replace(/(?!^)-/g, "");
  const firstDot = cleaned.indexOf(".");
  if (firstDot !== -1) {
    cleaned =
      cleaned.slice(0, firstDot + 1) +
      cleaned.slice(firstDot + 1).replace(/\./g, "");
  }
  return cleaned;
};
